<h4 mat-dialog-title>
  {{headingText}}
</h4>
<form *ngIf="form" [formGroup]="form" style="min-width: 35em;">
  <mat-form-field>
    <mat-label>Valore</mat-label>
    <input matInput type="number" min="0" formControlName="valore">
    <mat-icon matSuffix>euro</mat-icon>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Deroga percentuale</mat-label>
    <input matInput type="number" min="0" formControlName="deroga_percentuale">
    <span matSuffix>%</span>
  </mat-form-field>
  <div class="row">
    <div class="col-12 col-lg-9">
      <mat-form-field>
        <mat-label>Descrizione</mat-label>
        <input matInput formControlName="descrizione">
      </mat-form-field>

    </div>
    <div class="col-12 col-lg-3">
      <mat-form-field>
        <mat-label>
          Suggerimenti
        </mat-label>
        <mat-select>
          <mat-option (click)="addTextToControl('descrizione',suggerimento.testo)"
            (keydown.space)="addTextToControl('descrizione',suggerimento.testo)"
            *ngFor="let suggerimento of suggerimenti_per_control('Descrizione Somma Assicurata')">
            {{suggerimento.titolo}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <button mat-raised-button color="primary" (click)="edit()">
    Salva
  </button>
</form>